var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
export const RichText = forwardRef((_a, ref) => {
    var { field, tag, editable } = _a, otherProps = __rest(_a, ["field", "tag", "editable"]);
    if (!field || (!field.editable && !field.value)) {
        return null;
    }
    const htmlProps = Object.assign({ dangerouslySetInnerHTML: {
            __html: field.editable && editable ? field.editable : field.value,
        }, ref }, otherProps);
    return React.createElement(tag || 'div', htmlProps);
});
export const RichTextPropTypes = {
    field: PropTypes.shape({
        value: PropTypes.string,
        editable: PropTypes.string,
    }),
    tag: PropTypes.string,
    editable: PropTypes.bool,
};
RichText.propTypes = RichTextPropTypes;
RichText.defaultProps = {
    tag: 'div',
    editable: true,
};
RichText.displayName = 'RichText';
